<template>
  <div id="app" class="new-design" @click="handleBodyClick($event)">
    <div class="main-content">
      <div class="main-content-bg" :style="mainContentBgStyle"></div>
      <NavBar />
      <router-view v-if="showRouteContent" ref="content" />
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import $ from 'jquery'
import '@/assets/css/global.scss'
export default {
  name: 'layout',
  components: {
    NavBar
  },
  computed: {
    showRouteContent() {
      return this.$store.state.region.switchStatus === 'idle'
    },
    mainContentBgStyle() {
      let fullManiContentBgPaths = [
        '/',
        '/404',
        '/dashboard',
        '/dashboard/landing'
      ]
      let style = {
        'background-image': `url(${this.$store.state.customization.mainContentBg})`,
        width: fullManiContentBgPaths.includes(this.$route.path)
          ? '100vw'
          : 'calc(100vw - 190px)',
        height: '100%',
        'min-height': 'calc(100vh - 50px)',
        'background-size': 'cover',
        'background-position': 'center center'
      }
      if (this.$root.screenWidth <= 550) {
        style['min-height'] = '100vh'
        style['height'] = '100% !important'
        style['width'] = '100vw'
      }
      return style
    }
  },
  methods: {
    //Dismiss the popover by clicking outside
    handleBodyClick(e) {
      if (
        $(e.target).data('toggle') !== 'popover' &&
        $(e.target).parents('.popover.in').length === 0
      ) {
        this.$root.$emit('bv::hide::popover')
      }
    }
  }
}
</script>
